<template>
  <button
    type="button"
    class="ba-flex ba-items-center ba-px-5 ba-py-2 ba-leding-none ba-whitespace-no-wrap ba-font-semibold ba-text-white ba-bg-accent ba-rounded-full ba-select-none ba-duration-150 hover:ba-bg-primary"
    @click.prevent="$emit('click')"
  >
    <span class="ba-mr-3">
      <vis-icon-consistently class="ba-w-5 ba-h-5 ba-transform ba--rotate-90" />
    </span>
    <span class="ba-tracking-wide">Очередь</span>
    <span
      v-if="count"
      class="ba-ml-3"
    >
      +{{ count }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'vis-approval-queue-task-delegation-control',
  props: {
    count: {
      type: [String, Number],
      default: 1
    }
  }
}
</script>
